import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { Boxes, Eye, Lock, Inbox, ArrowRight } from "lucide-react";

export default function AdminOverview() {
  const [stats, setStats] = useState(null);
  useEffect(() => {
    api.get("/admin/analytics/summary").then((r) => setStats(r.data));
  }, []);

  const cards = stats
    ? [
        { l: "Systems", v: stats.total_systems, icon: Boxes, color: "text-[#D4AF37]" },
        { l: "Page Views", v: stats.total_page_views, icon: Eye, color: "text-blue-600" },
        { l: "Demo Unlocks", v: stats.total_demo_unlocks, icon: Lock, color: "text-emerald-600" },
        { l: "Total Leads", v: stats.total_leads, icon: Inbox, color: "text-slate-700" },
      ]
    : [];

  return (
    <div className="p-6 lg:p-10 max-w-6xl" data-testid="admin-overview">
      <h1 className="font-heading text-3xl font-bold tracking-tight">Overview</h1>
      <p className="text-slate-500 mt-1">Live activity across the showroom.</p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
        {cards.map((c) => {
          const Icon = c.icon;
          return (
            <Card key={c.l} className="p-6 rounded-2xl">
              <div className={`${c.color}`}><Icon className="w-5 h-5" /></div>
              <div className="mt-3 text-xs uppercase tracking-[0.18em] text-slate-500 font-semibold">{c.l}</div>
              <div className="mt-1 font-heading text-3xl font-bold text-slate-900">{c.v}</div>
            </Card>
          );
        })}
      </div>

      {stats && (
        <div className="mt-10 grid md:grid-cols-2 gap-4">
          <Card className="p-6 rounded-2xl">
            <div className="text-xs uppercase tracking-[0.18em] text-slate-500 font-semibold">Leads by Type</div>
            <div className="mt-4 space-y-3">
              {Object.entries(stats.leads_by_type).map(([k, v]) => (
                <div key={k} className="flex items-center justify-between text-sm">
                  <span className="capitalize text-slate-700">{k.replace(/_/g, " ")}</span>
                  <span className="font-mono font-semibold">{v}</span>
                </div>
              ))}
            </div>
          </Card>
          <Card className="p-6 rounded-2xl bg-slate-950 text-white">
            <div className="font-heading text-xl">Quick actions</div>
            <div className="mt-4 space-y-2">
              <Link to="/admin/systems" className="flex items-center justify-between p-3 rounded-xl bg-white/5 hover:bg-white/10">
                <span>Manage systems</span><ArrowRight className="w-4 h-4" />
              </Link>
              <Link to="/admin/leads" className="flex items-center justify-between p-3 rounded-xl bg-white/5 hover:bg-white/10">
                <span>Review inbox</span><ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </Card>
        </div>
      )}
    </div>
  );
}
